import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const ClientAuthContext = createContext(null);

export function ClientAuthProvider({ children }) {
  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/portal/auth/me");
      setClient(data);
    } catch {
      setClient(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const logout = useCallback(async () => {
    try { await api.post("/portal/auth/logout"); } catch (error) { console.error("Client logout request failed:", error); }
    setClient(false);
  }, []);

  const value = { client, setClient, loading, refresh: checkAuth, logout };
  return <ClientAuthContext.Provider value={value}>{children}</ClientAuthContext.Provider>;
}

export const useClientAuth = () => useContext(ClientAuthContext);
